export default __webpack_public_path__ + "static/media/Boots of Ferine Anger.ff1bebcb.jpg";